import api from './client'

// Módulo Marketing — Pata Email
export const marketingApi = {
  // MARKETING → Próxima Selección (lectura con trazabilidad).
  proximaSeleccion: (params) => api.get('/marketing/proxima-seleccion', { params }),
  segundaCompra: (params) => api.get('/marketing/segunda-compra', { params }),
  segundaCompraMuestra: () => api.post('/marketing/segunda-compra/muestra'),
  segundaCompraActivar: (activo) => api.post('/marketing/segunda-compra/activar', { activo }),
  // Newsletter de Experiencias (sugerencia #118): suscriptos desde la pestaña Experiencias.
  newsletterExperiencias: (params) => api.get('/marketing/newsletter-experiencias', { params }),
  // Recompra para dormidos (18 oct 2026): secuencia de 10 contactos.
  recompra: (params) => api.get('/marketing/recompra', { params }),
  recompraVistaPrevia: (cliente, estilo) => api.get('/marketing/recompra/vista-previa', { params: { cliente: cliente || undefined, estilo: estilo || undefined } }),
  recompraMuestra: (cliente) => api.post('/marketing/recompra/muestra', { cliente: cliente || undefined }),
  recompraConfigurar: (body) => api.post('/marketing/recompra/configurar', body),
  // Regalos empresariales (26 oct 2026): secuencia de 10 mails de la campaña.
  regalosEmp: (params) => api.get('/marketing/regalos-empresariales', { params }),
  regalosEmpMail: (archivo) => api.get('/marketing/regalos-empresariales/mail', { params: { archivo }, responseType: 'text' }),
  regalosEmpEnsayo: (archivo) => api.post('/marketing/regalos-empresariales/ensayo', { archivo: archivo || undefined }),
  regalosEmpRespondio: (email) => api.post('/marketing/regalos-empresariales/respondio', { email }),
  regalosEmpWhatsappPrueba: (telefono) => api.post('/marketing/regalos-empresariales/whatsapp-prueba', { telefono }),
  regalosEmpConfigurar: (body) => api.post('/marketing/regalos-empresariales/configurar', body),
  regalosEmpInscribir: (tanda, cantidad) => api.post('/marketing/regalos-empresariales/inscribir', { tanda, cantidad: cantidad || undefined }),
  regalosEmpLinkedin: (archivo) => {
    const fd = new FormData()
    fd.append('archivo', archivo)
    return api.post('/marketing/regalos-empresariales/linkedin', fd)
  },
  // Contactos
  contactos: (params) => api.get('/marketing/contactos', { params }),
  contactosResumen: () => api.get('/marketing/contactos/resumen'),
  crearContacto: (data) => api.post('/marketing/contactos', data),
  actualizarContacto: (id, data) => api.put(`/marketing/contactos/${id}`, data),
  bajaContacto: (id) => api.post(`/marketing/contactos/${id}/baja`),
  supresiones: (params) => api.get('/marketing/supresiones', { params }),

  // Listas / segmentos
  listas: () => api.get('/marketing/listas'),
  crearLista: (data) => api.post('/marketing/listas', data),
  actualizarLista: (id, data) => api.put(`/marketing/listas/${id}`, data),
  eliminarLista: (id) => api.delete(`/marketing/listas/${id}`),
  previewLista: (id) => api.post(`/marketing/listas/${id}/preview`),
  agregarContactosLista: (id, ids) => api.post(`/marketing/listas/${id}/contactos`, { ids }),

  // Plantillas
  plantillas: () => api.get('/marketing/plantillas'),
  sincronizarPlantillas: () => api.post('/marketing/plantillas/sincronizar'),
  plantilla: (id) => api.get(`/marketing/plantillas/${id}`),
  crearPlantilla: (data) => api.post('/marketing/plantillas', data),
  actualizarPlantilla: (id, data) => api.put(`/marketing/plantillas/${id}`, data),
  eliminarPlantilla: (id) => api.delete(`/marketing/plantillas/${id}`),
  testPlantilla: (id, email) => api.post(`/marketing/plantillas/${id}/test`, { email }),

  // Automations (secuencias automáticas)
  automations: () => api.get('/marketing/automations'),
  automation: (id) => api.get(`/marketing/automations/${id}`),
  crearAutomation: (data) => api.post('/marketing/automations', data),
  actualizarAutomation: (id, data) => api.put(`/marketing/automations/${id}`, data),
  eliminarAutomation: (id) => api.delete(`/marketing/automations/${id}`),
  activarAutomation: (id) => api.post(`/marketing/automations/${id}/activar`),
  pausarAutomation: (id) => api.post(`/marketing/automations/${id}/pausar`),
  inscripcionesAutomation: (id, params) => api.get(`/marketing/automations/${id}/inscripciones`, { params }),

  // Campañas
  campanas: (params) => api.get('/marketing/campanas', { params }),
  campana: (id) => api.get(`/marketing/campanas/${id}`),
  crearCampana: (data) => api.post('/marketing/campanas', data),
  actualizarCampana: (id, data) => api.put(`/marketing/campanas/${id}`, data),
  eliminarCampana: (id) => api.delete(`/marketing/campanas/${id}`),
  enviarCampana: (id, ahora = true) => api.post(`/marketing/campanas/${id}/enviar`, { ahora }),
  pausarCampana: (id) => api.post(`/marketing/campanas/${id}/pausar`),
  reanudarCampana: (id) => api.post(`/marketing/campanas/${id}/reanudar`),
  cancelarCampana: (id) => api.post(`/marketing/campanas/${id}/cancelar`),
  duplicarCampana: (id) => api.post(`/marketing/campanas/${id}/duplicar`),
  metricasCampana: (id) => api.get(`/marketing/campanas/${id}/metricas`),
  previewCampanaUrl: (id) => `/api/marketing/campanas/${id}/preview`,
}
